import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3146d565"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请扫码支付", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "codetrue",
  class: "logoimg"
}, null, -1))

import { onMounted } from 'vue'
//import { CreateOrderreturnorder ,getFlowers } from '../http/index' 
import { CreateOrderreturnorder  } from '../http/index' 

 //import { CreatePayUrlByCao919 ,CreatePayCenterUrl} from '../http/paycenter'
//import { CreatePayUrlByCao919 } from '../http/paycenter'
import { CreatePayCenterUrl} from '../http/paycenter'
import { ElMessage } from 'element-plus'
 import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import  QRCode from 'qrcodejs2-fix' 
// import QRCode from 'qrcodejs2-fix';

export default /*#__PURE__*/_defineComponent({
  __name: 'FlowerPay',
  setup(__props) {
 

const store = useStore();
 const router = useRouter();
let parms = {
  Id: 0,
  Type: window.location.href.split('type=')[1]
}
// let parmsprice = {
//     price: 1 
// }

let urls = window.location.href.match(/id=(\S*)&type=/);
if (urls != null) {
  parms.Id = parseInt(urls[1])
}
onMounted(async () => {

  //验证登录信息
  if (localStorage["NickName"] == undefined) {
    ElMessage.warning("请登录后再点击购买！")
    return;
  }

    //根据当前的用户信息，产品信息生成一笔订单
    try {
    let res = (await CreateOrderreturnorder({ FlowerId: parms.Id,userCode:store.state.userCode })).data
    console.log(res)
    if (res.isSuccess) {
      ElMessage({
        message: '创建订单成功！可微信扫描支付！',
        type: 'success',
      }) 

      //const  info  = (await getFlowers(parms)).data.result[0]
    
      //api/pay/CreatePayCenterUrl/{clientid}/{unionid}/{orderId}/{productid}/{totalPay}/{description}
    const restrue = (await CreatePayCenterUrl( 'flower',res?.result?.userCode?res?.result?.userCode :res?.result?.userId,res?.result?.orderNumber,res?.result?.flowerId,  res?.result?.price*100,"Flower520mus")).data as any;
    console.log(restrue);
    let qrcodetrue  = new QRCode('codetrue', {
        width: 300,// 二维码的宽
        height: 300,// 二维码的高
        text: restrue.value ? restrue.value : 'http://flower.520mus.top', // 二维码的内容
        colorDark: '#000',// 二维码的颜色
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H 
    });
    console.log(qrcodetrue);  
       
    } else {
      ElMessage.error("创建订单失败，请联系系统管理员！")
    }
  } catch (error) {
    localStorage.removeItem('NickName');
    localStorage.removeItem('token');
    store.commit('SettingNickName', undefined)
    ElMessage.warning("请登录后刷新列表")
  }


// console.log(parmsprice.price );
//     // qrcodeimg.value= (await CreatePayUrlByCao919(parmsprice.Id)).data as any
//     const res = (await CreatePayUrlByCao919(parmsprice.price)).data as any;
//     console.log(res);
//     let qrcode  = new QRCode('code', {
//         width: 300,// 二维码的宽
//         height: 300,// 二维码的高
//         text: res.value ? res.value : '', // 二维码的内容
//         colorDark: '#000',// 二维码的颜色
//         colorLight: '#fff',
//         correctLevel: QRCode.CorrectLevel.H 
//     });
//     console.log(qrcode); 
    
// //api/pay/CreatePayCenterUrl/{clientid}/{unionid}/{orderId}/{productid}/{totalPay}/{description}
//       const  info  = (await getFlowers(parms)).data.result[0]
//       console.log(info); 
//     const restrue = (await CreatePayCenterUrl( 'flower',store.state?.userCode,'0',info.Id,  parmsprice.price,info.title)).data as any;
//     console.log(restrue);
//     let qrcodetrue  = new QRCode('codetrue', {
//         width: 300,// 二维码的宽
//         height: 300,// 二维码的高
//         text: restrue.value ? restrue.value : '', // 二维码的内容
//         colorDark: '#000',// 二维码的颜色
//         colorLight: '#fff',
//         correctLevel: QRCode.CorrectLevel.H 
//     });
//     console.log(qrcodetrue); 
  }) 

const goToPay = async () => {
  //验证登录信息
  if (localStorage["NickName"] == undefined) {
    ElMessage.warning("请登录后再点击购买！")
    return;
  }
  
  //根据当前的用户信息，产品信息生成一笔订单  //true 业务 这里更新订单状态
  try {
    //let res = (await CreateOrder({ FlowerId: parms.Id,userCode:store.state.userCode })).data
   // console.log(res)
    //if (res.isSuccess) {
    //  ElMessage({
    //    message: '创建订单成功！',
     //   type: 'success',
     // }) 
      
       router.push({ path: '/personcenter' });
    //} else {
    //  ElMessage.error("创建订单失败，请联系系统管理员！")
    //}
  } catch (error) {
    localStorage.removeItem('NickName');
    localStorage.removeItem('token');
    store.commit('SettingNickName', undefined)
    ElMessage.warning("请登录后刷新列表")
  }



}

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              class: "box-card",
              style: {"display":"block","width":"346px","margin":"0px auto"}
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "warning",
              round: "",
              onClick: goToPay
            }, {
              default: _withCtx(() => [
                _createTextVNode("模拟支付")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})